import {
  AddRecipeToGroceryListResponse,
  DeleteResponse,
  RecipeIdRequestBody,
} from '../@aligre/types/api'
import apiFetch from './apiFetch'

export async function addRecipeToGroceryList(recipeId: string) {
  return await apiFetch<RecipeIdRequestBody, AddRecipeToGroceryListResponse>(
    'me/grocery',
    'POST',
    { recipeId }
  )
}

export async function deleteRecipeFromGroceryList(recipeId: string) {
  return await apiFetch<RecipeIdRequestBody, DeleteResponse>(
    'me/grocery',
    'DELETE',
    { recipeId }
  )
}
